import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CheckoutPage } from './pages/CheckoutPage';
import { ContactPage } from './pages/ContactPage';
import { OfferPage } from './pages/OfferPage';
import { CheckoutBundlePage } from './pages/CheckoutBundlePage';
import { VslPage } from './pages/VslPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<CheckoutBundlePage data-id="element-3" />} data-id="element-2" />
        <Route path="/vsl" element={<VslPage data-id="element-5" />} data-id="element-4" />
        <Route path="/checkout" element={<CheckoutBundlePage data-id="element-7" />} data-id="element-6" />
        <Route path="/checkout-legacy" element={<CheckoutPage data-id="element-9" />} data-id="element-8" />
        <Route path="/contactanos" element={<ContactPage data-id="element-11" />} data-id="element-10" />
        <Route path="/offer" element={<OfferPage data-id="element-13" />} data-id="element-12" />
      </Routes>
    </BrowserRouter>;
}